import type { CSSInterpolation } from '@emotion/serialize';

import { BuildType } from 'src/enums/build/build-type';
import { fonts } from 'src/styling/constants';

export type TextStyles = {
  header: CSSInterpolation;
};

export const getTextStyles = (buildType: BuildType): TextStyles => {
  switch (buildType) {
    case BuildType.HARBOUR: {
      return {
        header: [
          fonts.harbourBold,
          {
            textTransform: 'uppercase',
            letterSpacing: '0.5rem',
            lineHeight: 1.2,
          },
        ],
      };
    }
    case BuildType.MERIDIAN: {
      return {
        header: [
          fonts.bold,
          {
            lineHeight: '3rem',
          },
        ],
      };
    }
    default: {
      return {
        header: [
          fonts.bold,
          {
            lineHeight: 1,
          },
        ],
      };
    }
  }
};
